import { useState, useEffect } from 'react';
import warn from '../utils/warn.js';

function useHasFocus(focusElementRef, onFocus) {
  const [hasFocus, setHasFocus] = useState(false);
  useEffect(() => {
    const focusElement = focusElementRef.current;
    if (!focusElement) {
      warn("No element found to focus");
      return () => {};
    }
    function handleFocusEvent(ev) {
      if (onFocus) {
        onFocus(ev);
      }
      setHasFocus(ev.type === "focus");
    }
    focusElement.addEventListener("focus", handleFocusEvent);
    focusElement.addEventListener("blur", handleFocusEvent);
    return () => {
      if (focusElement) {
        focusElement.removeEventListener("focus", handleFocusEvent);
        focusElement.removeEventListener("blur", handleFocusEvent);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusElementRef]);
  return hasFocus;
}

export { useHasFocus };
